<template>
  <div>
    <div
      v-if="check.name"
      class="grid-parent-items-wrapper items-center gap-3 w-full pl-3 px-2"
    >
      <font-awesome-icon
        icon="grip-vertical"
        class="text-base-content-300 text-gray-500"
      />
      <div
        class="grid-parent-items-inner justify-between transition-all duration-200 py-1 items-center gap-3 rounded-xl cursor-pointer"
      >
        <div class="w-full bg-white rounded-md">
          <div class="w-full">
            <div
              class="flex w-full gap-3 items-center justify-between text-sm p-2"
            >
              <!-- Input for the label when edited -->
              <div class="flex justify-between w-3/12">
                <span
                  v-tippy
                  :content="fieldLabel"
                  class="section_name bg-transparent w-48 border-0 outline-none p-1 text-md text-base-content font-semibold truncate"
                >
                  {{ fieldLabel }}
                </span>
              </div>
              <div class="w-3/12 flex justify-start">
                    <span class ="optionHeading" v-for="(entity, index) in check.entity_types" :key="entity.id">
                        {{ index > 0 ? ', ' : '' }}{{ entity.name }}
                    </span>
              </div>

              <!-- Permissions button -->
              <!-- <div class="flex justify-end w-2/12">
                !-- :disabled="!isEditMode" ->
                <DropdownButton
                  :title="$t('pages.workflow_engine.permissions')"
                  @click="showGroupsModal"
                />
              </div> -->

              <!-- Expand/Collapse and Remove button -->
              <div class="flex items-center justify-end gap-3 w-1/12">
                <!-- <span
                  class="text-white-text text-sm flex items-center gap-2 cursor-pointer"
                  @click="onExpanded"
                >
                  <uparrow v-if="isExpanded" />
                  <downarrow v-else />
                </span> -->
                <div>
                    <DropdownButton
                      :title="$t('pages.workflow_engine.permissions')"
                      @click="showGroupsModal"
                    />
                </div>
                <button
                  class="cursor-pointer p-3 text-base text-base-content-300 w-6 h-6 flex items-center justify-center rounded-full text-center"
                  :class="{
                    formListItem__disabled: check.disabled || disabled,
                    'hover:bg-primary-focus hover:text-white-text': !isViewMode,
                    'opacity-50 cursor-not-allowed': isViewMode,
                  }"
                  @click="removeCheck(check)"
                >
                  <font-awesome-icon
                    icon="times"
                    class="cursor-pointer text-primary hover:text-primary-focus text-lg"
                  />
                </button>
              </div>
            </div>
          </div>
          <div :class="{ expanded: isExpanded, collapsed: !isExpanded }">
            <div
              v-if="isExpanded"
              class="flex justify-between items-center text-sm gap-3 bg-white pl-2 pb-1"
            >
              <input
                v-if="editedDescription"
                v-model="check.description"
                @click.stop="$emit('fieldNameClick', check)"
                @blur="onUpdateFieldDescription(check)"
                :class="
                  !check.description
                    ? 'border border-dashed border-red-300 '
                    : ''
                "
                type="text"
                class="section_name w-full bg-transparent border-0 outline-none p-1 text-md text-base-content focus:bg-gray-200 rounded focus:border-none border-b border-dashed border-gray-300 truncate"
              />
              <span
                v-else
                v-tippy
                :content="fieldDescription"
                class="section_name bg-transparent truncate w-96 border-0 outline-none p-1 text-md text-base-content font-normal truncate"
              >
                Check Description : {{ fieldDescription }}
              </span>
              <!-- Edit button for description -->
              <div
                v-if="this.$route.params.action !== 'view' && isEditPermission"
                class="h-8 w-8 flex items-center justify-center rounded-full hover:bg-dvbrandcolor hover:text-white-text transition-all duration-150"
                :class="
                  editedDescription
                    ? 'bg-dvbrandcolor text-white-text'
                    : 'text-primary'
                "
                @click.stop="onEditDescription()"
              >
                <font-awesome-icon
                  icon="edit"
                  class="cursor-pointer text-sm fill-current"
                  v-bind:style="{
                    opacity: this.$route.params.action !== 'view' ? 1 : 0.5,
                    cursor:
                      this.$route.params.action !== 'view'
                        ? 'pointer'
                        : 'not-allowed',
                  }"
                />
              </div>
            </div>
          </div>
        </div>

        <!-- Expanded content section -->
      </div>
    </div>

    <!-- Optionally, can be moved to the parent level -->
    <PermissionControllerEditView
      ref="permissions-controller-edit-view"
      :disabled="!isEditMode"
      :groups="mappedPermissionGroups"
      :id="check.check_id"
      :selected="selectedPermissionGroups"
      :selectedViewOrEdit="selectedPermissionGroupsViewOrEdit"
      :loading="checkPermissions.loading"
      @submit="onPermissionGroupsSubmit"
    />
  </div>
</template>

<script>
// import uparrow from "@shared/assets/icon/svgs/uparrow.svg";
// import downarrow from "@shared/assets/icon/svgs/downarrow.svg";
import { Dropdown as DropdownButton } from "@shared/components/buttons";
import PermissionControllerEditView from "@shared/components/packages-form-edit-table/components/PermissionControllerEditView.vue";
import {
  getCheckPermissionsViewEdit,
  updateCheckPermissionsViewEdit,
} from "./services";
import {
  getPermissionGroupsIdList,
  mapPermissionGroup,
} from "./components/utils";

export default {
  name: "fields",
  props: {
    currentTab: {
      type: String,
    },
    showSidePanel: {
      type: Boolean,
      default: false,
    },
    activeFieldPanel: {
      type: Object,
      default: () => {},
    },
    check: {
      type: Object,
      default: () => {},
    },
    packageId: {
      type: String,
      required: true,
    },
    options: {
      type: Object,
      default: () => {},
    },
    section: {
      type: Object,
      default: () => {},
    },
    allReportsRoles: {
      type: Array,
      default: () => [],
    },
    fieldClass: {
      type: String,
      default: "",
    },
    updateFieldAttributesMethod: {
      type: Function,
    },
    showDeleteIcon: {
      type: Boolean,
      default: true,
    },
    draggable: {
      type: Boolean,
      default: true,
    },
    isEditPermission: {
      type: Boolean,
      default: true,
    },
    inPackage: {
      type: Boolean,
    },
    isBlock: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: null,
    },
    entityType: {
      type: Object,
      required: true,
    },
    // all permission groups
    // permissionGroups: {
    //     type: Object,
    //     default: () => ({
    //         client: [],
    //         tenant: [],
    //     })
    // }
  },
  components: {
    // uparrow,
    // downarrow,
    DropdownButton,
    PermissionControllerEditView,
  },
  data() {
    return {
      edited: false,
      rolesLoading: false,
      newValue: "",
      oldValue: "",
      isExpanded: false,
      newValueDesc: "",
      oldValueDesc: "",
      editedDescription: false,
      oldCheckLabel: "",
      checkPermissions: {
        loading: false,
        data: {
          client: [],
          tenant: {},
        },
      },
    };
  },
  computed: {
    isEditMode() {
      return this.$route.params.action === "edit" && !!this.isEditPermission;
    },
    getElementName() {
      let text = "";
      const max_length = 25;
      if (this.check.name && this.check.name.length > max_length) {
        text = this.check.name.substring(0, max_length) + " ...";
        return text;
      } else {
        return this.check.name;
      }
    },
    fieldLabel() {
      return this.getFieldLabel(this.check);
    },
    fieldDescription() {
      return this.getFieldDescription(this.check);
    },
    // useblockvisible: {
    //     get() {
    //         return this.check.block_visibility
    //     },
    //     set(val) {
    //         this.check.block_visibility = val;
    //     },
    // },
    canDeleteField() {
      return !this.check.block_id;
    },
    selectedPermissionGroups() {
      return getPermissionGroupsIdList(this.mappedPermissionGroups, {
        filter: (el) => !!el.selected,
        modifier: (el) => el.group_id,
      });
    },
    selectedPermissionGroupsViewOrEdit() {
      return getPermissionGroupsIdList(this.mappedPermissionGroups, {
        modifier: (el) => ({
          id: el.id || el.group_id,
          read: el.read,
          write: el.write,
        }),
      });
    },
    mappedPermissionGroups() {
      const { tenant, clients } = this.checkPermissions.data;
      const tenantGroups = tenant?.groups || [];
      const clientGroups = clients || [];

      const mappedTenant = mapPermissionGroup(tenantGroups, {
        modifier: (el) => ({
          ...el,
          id: el.group_id,
        }),
      });
      const mappedClient = mapPermissionGroup(clientGroups, {
        modifier: (el) => ({
          ...el,
          client_id: el.name, // TODO check
          client_name: el.name,
        }),
        listItemModifier: (el) => ({
          ...el,
          group_name: el.title,
        }),
      });
      return {
        tenant: mappedTenant,
        client: mappedClient,
      };
    },
    isViewMode() {
      return this.$route.params.action === "view" || false;
    },
  },
  // mounted() {
  //     this.oldValue = this.check.label;
  //     this.oldValueDesc =  this.check.description;
  // },
  methods: {
    fieldNameClicked(check) {
      this.oldValue = check.label?.toString().trim();
    },
    getFieldLabel(field) {
      return field.label || field.name;
    },
    getFieldName(field) {
      return field.name;
    },
    removeCheck(check) {
      this.$emit("removeCheck", check);
    },
    getFieldDescription(field) {
      return field.description;
    },
    /* async onUpdateFieldLabel(check) { // *********DELETE*********
            this.edited = false;
            if (!check.label) {
                this.check.label = this.oldCheckLabel;
                this.$toast.error("label cannot be empty");
                return;
            }
            else if(this.oldValue === check.label){
                return;
            } else {
                // this.check.label = this.oldCheckLabel;
                // check.label = this.newValue;
                this.$emit('updateFieldLabel', { check })
            }
        },
        onUpdateFieldDescription(check){ // *********DELETE*********
            this.editedDescription = false;
            this.check.description = this.oldValueDesc;
            check.description = this.newValueDesc;
            this.$emit('updateFieldLabel', { check })
        }, */
    onExpanded() {
      this.isExpanded = !this.isExpanded;
    },
    onEdit(check) {
      this.oldCheckLabel = check.label?.toString()?.trim();
      if (this.$route.params.action == "view") {
        return;
      }
      // if (!this.check.label) {
      //     this.$toast.error("Label cannot be empty");
      //     return;
      // }
      this.edited = !this.edited;
    },
    onEditDescription() {
      if (this.$route.params.action == "view") {
        return;
      }
      this.editedDescription = !this.editedDescription;
    },

    async showGroupsModal() {
      this.checkPermissions.loading = true;
      this.$refs["permissions-controller-edit-view"]?.showModal();
      try {
        const response = await getCheckPermissionsViewEdit({
          formId: this.check.check_id,
          packageId: this.packageId,
          entityTypeId: this.entityType.id,
        });

        this.checkPermissions.data = response;

      } catch (error) {
        console.error("Failed to fetch check permissions", error);
      }
      this.checkPermissions.loading = false;
    },

    isSelectedModifier(el, selected = this.selectedPermissionGroupsViewOrEdit, type) {
      const id = el.id || el.group_id;
      if (type) {
        if (selected && Array.isArray(selected.viewOrEdit)) {
          const found = selected.viewOrEdit.find(sel => sel.id === id);
          if (!found) return false;
          return !!found[type];
        }
        return false;
      }
      if (selected && Array.isArray(selected.viewOrEdit)) {
        return selected.viewOrEdit.some((sel) => sel.id === id && (sel.read || sel.write));
      } else if (selected && Array.isArray(selected.ids)) {
        return selected.ids.some((sel) => sel.id === id);
      }
      return false;
    },

    /**
     * @param {String[]} selected selected group IDs
     */
    async onPermissionGroupsSubmit(selected) {
      this.checkPermissions.loading = true;
      try {
        const { tenant, clients } = this.checkPermissions.data;

        const payload = {
          tenant: {
            ...tenant,
            groups: mapPermissionGroup(tenant.groups, {
              modifier: (el) => ({
                ...el,
                read: this.isSelectedModifier(el, selected, "read"),
                write: this.isSelectedModifier(el, selected, "write"),
                // selected: this.isSelectedModifier(el, selected),
              }),
            }),
          },
          clients: mapPermissionGroup(clients, {
            modifier: (el) => ({
              ...el,
              read: this.isSelectedModifier(el, selected, "read"),
              write: this.isSelectedModifier(el, selected, "write"),
              // selected: this.isSelectedModifier(el, selected),
            }),
          }),
        };

        await updateCheckPermissionsViewEdit({
          formId: this.check.check_id,
          entityTypeId: this.entityType.id,
          packageId: this.packageId,
          data: payload,
        });

        // update stored data:
        this.checkPermissions.data = payload;
      } catch (error) {
        console.error("Failed to update check permissions:", error);
      }
      this.checkPermissions.loading = false;
      this.$refs["permissions-controller-edit-view"]?.hideModal();
    },
  },
  // watch: {
  //     'check.label': function (newVal, oldVal) {
  //         this.newValue = newVal;
  //         this.oldValue =  oldVal
  //         console.log(oldVal, newVal);
  //     },
  //     'check.description': function (newVal, oldVal) {
  //         this.newValueDesc = newVal;
  //         this.oldValueDesc = oldVal;
  //         console.log(oldVal);
  //     },
  // },
};
</script>

<style lang="scss" scoped>
.block_visible {
  position: relative;
  align-self: center;
  padding-left: 10px;
}
.packageFieldRole {
  margin-left: 1.8%;
}
.optionHeading {
  color: #0236bb;
  font-weight: 400;
}
.optionCircle {
  margin-top: 5px;
}

.field-tags_container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
}
.block-role-panel-pad {
  padding-left: 18px;
}

.collect-data {
  max-width: 220px;
  min-width: 810px;
  width: 220px;
  @apply bg-primary-100 border-primary-100;
  @apply h-7;
}

.grid-parent-items-wrapper {
  display: grid;
  grid-template-columns: 16px 1fr;
}

.grid-parent-items-inner {
  display: grid;
  grid-template-columns: 1fr;
}

.grid-child-items-wrapper {
  display: grid;
  grid-template-columns: 100px 1fr 50px;
}
.item {
  cursor: move;
  padding: 10px;
  background: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-bottom: 10px;
}

/* Optional: You can add styling for the ghost class (the element while being dragged) */
.ghost {
  opacity: 0.5;
}
</style>
